export default __webpack_public_path__ + "static/media/645.57479cd5.jpg";